import useUserStore from 'clientStore/useUserStore';
import { USER_ROLES } from 'data/user/user.constants';

const useUser = () => {
  return useUserStore((state) => ({
    ...state.user,
    displayName: `${state.user?.first_name} ${state.user?.last_name}`,
    isClient: false
  }));
};

export default useUser;
